
import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

type ExitModalPaymentProps = {
  show: boolean;
  onHide: () => void;
  onShow?: () => void;
};

const ExitModalPayment: React.FC<ExitModalPaymentProps> = ({ show, onHide, onShow }) => {
  useEffect(() => {
    if (show && onShow) onShow();
  }, [show, onShow]);
  return (
  <Modal show={show} onHide={onHide} centered size="lg" className="exit-modal">
      <Modal.Header closeButton>
        <Modal.Title>Leaving so soon?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You're almost finished. Choose your payment option to secure this important coverage for you and your family.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default ExitModalPayment;
